<script>
	const accountService = require('services/accountService');
	const page = require('page');
	const classService = require('services/classService');
	const userContext = require('core/userContext');
	const utilities = require('../utilities');
	const Serializer = require('async/Serializer');
	const model = require('model/model');
	const pubsub = require('events/pubsub');
	const _ = require('underscore');
	const logger = require('utilities/logger');

	var PLACEHOLDER =
		'Type or copy and paste each student on a new line.\n\nExample:\n\nAdam Smith\nHarriet Tubman\nAlexander Hamilton\nShel Silverstein\nEleanor Roosevelt\nItalo Calvino';

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},
		data: function () {
			return {
				PLACEHOLDER: PLACEHOLDER,
				parsedStudents: [],
				teacherRosterForm: {},
				successCount: null,
				loading: false
			};
		},

		methods: {
			addKids: function (data, cb) {
				var textAreaValue = this.teacherRosterForm.roster;

				var self = this,
					originalClassCode = model.get('classCode'),
					serializer = new Serializer(),
					modelData = model.get('newClass'),
					returnToProduct = model.get('returnToProduct');

				self.loading = true;
				if (!originalClassCode) {
					if (!modelData || !modelData.name) {
						pubsub.publish('message-error', 'A technical issue occurred creating a class, please try again');
						utilities.closeModals();
						model.set('classAdmin', 'active');
						model.remove('classCode');
						logger.error('No class data found trying to create class with roster', JSON.stringify(modelData));
						return;
					}

					serializer.queue(function () {
						return classService
							.createClass({
								n: modelData.name,
								g: String(modelData.grade),
								rt: 'teacher'
							})
							.then(function (result) {
								model.remove('newClass');

								userContext.setToken(result.token);

								return result;
							});
					});
				}

				serializer.queue(function (body) {
					var classCode = (body && body.cc) || originalClassCode;

					return accountService
						.createTeacherRosteredStudents({
							cc: classCode,
							students: _.filter(textAreaValue.split('\n'), function (v) {
								return v.trim();
							})
						})
						.then(function (result) {
							self.successCount = result.count;

							if (!originalClassCode) {
								page('/class-admin');
								model.set('classAdmin', 'roster');
								model.set('classCode', classCode);
								if (returnToProduct) {
									model.set('returnToProduct', returnToProduct);
								}

								pubsub.publish('message-success', 'Class "' + modelData.name + '" created');
							}

							utilities.openModal('#modal-add-tr-students-success');
							pubsub.publish('student-added');

							self.teacherRosterForm.roster = '';
							//                    pubsub.publish('class-creation-complete');

							cb(null, result);
						})
						.finally(() => (self.loading = false));
				});

				serializer.execute().fail(cb);
			}
		}
	};
</script>
<style lang="sass">
	ol.confirm-student-list {
		max-height: 14em;
		overflow-y: auto;
	}
</style>
<template>
	<div>
		<div
			id="modal-add-tr-students"
			class="modal"
			data-modal-window
			v-bind:class="{ 'modal-loading-data': loading }">
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Add Students To Class</h2>
							</header>
							<div class="modal-content-main -form">
								<form-submitter
									form-name="teacherRosterForm"
									:form-data.sync="teacherRosterForm"
									:submit-to="addKids"
									class="form"
									novalidate
									no-close-modal
									ref="teacherRosterForm">
									<auto-form-row
										v-bind:data.sync="teacherRosterForm.roster"
										type="roster"
										v-bind:placeholder="PLACEHOLDER"
										required
										unsafe>
									</auto-form-row>
									<div class="text-centered">
										<auto-form-row
											v-bind:all-valid="teacherRosterForm.allValid"
											type="submit"
											row-class="button -large">
											Add
										</auto-form-row>
									</div>
								</form-submitter>
							</div>
						</section>
						<div class="modal-loading-content">Please wait, data is loading.</div>
					</div>
				</div>
			</div>
		</div>
		<div
			id="modal-add-tr-students-success"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2 v-if="successCount == 1">{{ successCount }} Student Added</h2>
								<h2 v-if="successCount != 1">{{ successCount }} Students Added</h2>
							</header>
							<div class="modal-content-main text-centered">
								<h3>The password for all added students is:</h3>
								<h3>1234</h3>
								<div>You or your students can change their individual passwords.</div>
								<div>&nbsp;</div>
								<div>
									<span
										class="button"
										data-modal-close
										>OK</span
									>
								</div>
								<div>&nbsp;</div>
								<div>
									<span
										class="button -outline"
										data-modal="#modal-add-tr-students"
										>Add More Students</span
									>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
